import { render, staticRenderFns } from "./ImportView.vue?vue&type=template&id=059dcbc2&scoped=true"
import script from "./ImportView.vue?vue&type=script&lang=ts"
export * from "./ImportView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059dcbc2",
  null
  
)

export default component.exports